<template lang="pug">
// STATUS
div
  .md-subheading Status
  md-radio.md-primary(v-model='selected', @change='onChange', md-value='archived')  Archived
  md-radio.md-primary(v-model='selected', @change='onChange', md-value='draft')     Draft
  md-radio.md-primary(v-model='selected', @change='onChange', md-value='public')    Live
</template>
<script>
  export default {
    props: {
      value: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        selected: this.value
      };
    },
    methods: {
      onChange(value) {
        this.$emit('input', value);
      }
    },
    watch: {
      value(newValue) {
        if (newValue) {
          this.selected = newValue;
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/shared-components/StatusRadio.vue